<template>
  <div class="scan">
    <div class="scanBanner" @click="scanCode">
      <img class="scanBannerImg" src="../../static/home/saoma.png" />
    </div>
    <!--    <div class="scanbox">
      <div class="scantop" @click="scanCode">
        <img class="scanimg" src="/static/home/scan_white.png" />
        <div class="text">点击扫码核销</div>
      </div>
     <div class="scanbottom">
        <input class="scaninput" v-model="cardNo" placeholder="请输入卡号进行核销" />
        <div class="scanbotton" @click="toVerifyMesg">搜索</div>
      </div>
    </div> -->
    <taber></taber>
  </div>
</template>

<script>
import httper from "../../api/http";
import taber from "@/components/taber/taber";
import { Dialog } from "vant";
export default {
  components: {
    taber
  },
  data() {
    return {
      cardNo: "",
      userinfo: ""
    };
  },
  created() {
    let that = this;
    this.getwechat({
      url: location.href.split("#")[0]
    });
    console.log("userinfo", JSON.parse(localStorage.getItem("userinfo")));
    this.request("userInfo");
    // if(localStorage.getItem('userinfo')){
    //   let userinfo = JSON.parse(localStorage.getItem('userinfo'));
    //   console.log("userinfo",userinfo)
    //   console.log("userinfo.is_bind == 0",userinfo.is_bind == 0)
    //   if (userinfo.is_bind == 0) {
    //     Dialog.alert({
    //       title: '提示',
    //       message: '请先绑定商家账号',
    //       theme: 'round-button',
    //     }).then(() => {
    //       that.$router.push({
    //         path: "/signIn"
    //       })
    //     });
    //   }
    // }
  },
  mounted() {},
  methods: {
    toVerifyMesg() {
      let that = this;
      if (that.userinfo.is_bind == 0) {
        Dialog.alert({
          title: "提示",
          message: "请先绑定商家账号",
          theme: "round-button"
        }).then(() => {
          that.$router.push({
            path: "/signIn"
          });
        });
      }
      // const specialUserIds = [2, 3];
      // console.log("that.userinfo.id", that.userinfo.id);
      // if (specialUserIds.includes(that.userinfo.id)) {
      //   console.log("进入verifyMesgcopy");
      //   this.$router.push({
      //     path: "/verifyMesgcopy",
      //     query: {
      //       cardNo: that.cardNo
      //     }
      //   });
      // } else {}
        console.log("进入verifyMesg");
        this.$router.push({
          path: "/verifyMesg",
          query: {
            cardNo: that.cardNo
          }
        });
      
    },
    //获取微信配置信息接口
    getwechat(requestData = {}) {
      httper.get("wechat/wechat/sign-package", requestData, res => {
        console.log(res);
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
        });
      });
    },
    scanCode() {
      let that = this;
      if (that.userinfo.is_bind == 0) {
        Dialog.alert({
          title: "提示",
          message: "请先绑定商家账号",
          theme: "round-button"
        }).then(() => {
          that.$router.push({
            path: "/signIn"
          });
        });
      }

      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          // onlyFromCamera: true,
          scanType: ["qrCode"], //"qrCode","barCode" 二维码、一维码
          success: function(res) {
            // console.log("scan",res)
            // window.location.href = "http://192.168.2.158:8080/verifyMesg/?source=yy&card_no=v9xO80sxsEC43820"
            if (res) {
              let result = res.resultStr;
              window.location.href = result;
              // let result = (res.resultStr).split(",")
              // that.couponCode = result[1]
              // console.log('that.codePassword', that.couponCode)
            }
            // var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            // window.location.href = result; //因为我这边是扫描后有个链接，然后跳转到该页面
          }
        });
      });
    },
    // 调用接口
    request(type = "", requestData = {}) {
      let that = this;
      switch (type) {
        //获取用户信息
        case "userInfo":
          httper.get(
            "wechat/user/info",
            requestData,
            function(res) {
              if (res.code == 0) {
                let userinfo = res.data;
                that.userinfo = userinfo;
                console.log("userinfo", userinfo);
                console.log("userinfo.is_bind == 0", userinfo.is_bind == 0);
                if (userinfo.is_bind == 0) {
                  that.$router.push({
                    path: "/signIn"
                  });
                }
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
      }
    }
  }
};
</script>

<style>
.scanBanner {
  width: calc(100% - 20px);
  margin: 10px;
  margin-bottom: 100px;
  /*    position: fixed;
    top: 10px; */
}

.scanBannerImg {
  width: 100%;
  height: 100%;
}

.scanbox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.scantop {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  height: 350px;
  box-sizing: border-box;
  border-radius: 0 0 10% 10%;
  /*   background-color: #64acf8; */
  background: linear-gradient(160deg, #1496f1, #e0f0fa);
  margin-bottom: 20px;
}

.scanimg {
  width: 200px;
  height: 200px;
  margin-bottom: 12px;
}

.scanbottom {
  width: calc(100% - 40px);
  margin: 20px;
  display: flex;
  align-items: center;
}

.scaninput {
  width: calc(100% - 70px);
  /* height: 30px; */
  border-radius: 8px;
  border: 1px solid #dfdfdf;
  padding: 10px;
  box-sizing: border-box;
}

.scanbotton {
  width: 60px;
  height: 30px;
  border-radius: 16px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #ffffff;
  background-color: #64acf8;
}

.text {
  font-size: 15px;
  color: #ffffff;
}

input::-webkit-input-placeholder {
  text-align: start;
}
</style>



// WEBPACK FOOTER //
// src/pages/HomeIndex.vue